<template>
  <b-modal
    v-model="visible"
    title="Leave page?"
    centered
    hide-footer
    @hide="onHide"
  >
    <div class="mb-3 leave-page-warning-message">
      {{ message }}
    </div>
    <div class="text-right leave-page-warning-actions">
      <base-button type="secondary" class="mr-2" @click="stayOnPage">
        Stay on page
      </base-button>
      <base-button type="danger" class="bg-danger" @click="leavePage">
        Leave page
      </base-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "LeavePageWarningModal",
  props: {
    message: {
      type: String,
      default:
        "You are in the progress of creating a quote for your customer - if you leave this page your indicative premium will be lost and not sent to your customer."
    }
  },
  data() {
    return {
      visible: false,
      resolveOpen: null
    };
  },
  methods: {
    open() {
      this.visible = true;
      return new Promise(resolve => {
        this.resolveOpen = resolve;
      });
    },
    leavePage() {
      this.visible = false;
      if (this.resolveOpen) {
        this.resolveOpen(true);
        this.resolveOpen = null;
      }
    },
    stayOnPage() {
      this.visible = false;
      if (this.resolveOpen) {
        this.resolveOpen(false);
        this.resolveOpen = null;
      }
    },
    onHide() {
      if (this.resolveOpen) {
        this.resolveOpen(false);
        this.resolveOpen = null;
      }
    }
  }
};
</script>

<style scoped>
.leave-page-warning-message {
  padding-bottom: 0.5rem;
}

.leave-page-warning-actions {
  padding-bottom: 0.5rem;
}

::v-deep .modal-body {
  padding-bottom: 1.5rem !important;
}
</style>
